import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  border-bottom: ", ";\n  &:hover,\n  &:active {\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { ADVENTURE_GREEN, ADVENTURE_GREEN_FOCUSED, INACTIVE_GRAY, NIGHTINGALE_BLACK, RIOJA_RED, RIOJA_RED_FOCUSED } from '../../colors';
import { css } from 'styled-components';
import { getVariantName } from '../../helpers/variants';
var LINK_COLOR = {
  default: NIGHTINGALE_BLACK,
  secondary: INACTIVE_GRAY,
  primary: ADVENTURE_GREEN,
  alarm: RIOJA_RED,
  dark: NIGHTINGALE_BLACK
};
var LINK_HOVER_COLOR = {
  default: ADVENTURE_GREEN,
  secondary: ADVENTURE_GREEN,
  primary: ADVENTURE_GREEN_FOCUSED,
  alarm: RIOJA_RED_FOCUSED,
  dark: ADVENTURE_GREEN
};
var LINK_BORDER_BOTTOM = {
  default: "1px solid " + ADVENTURE_GREEN,
  secondary: 'none',
  primary: 'none',
  alarm: 'none',
  dark: 'none'
};
export var baseLinkMixin = css(_templateObject(), function (props) {
  return LINK_COLOR[getVariantName(props)] || LINK_COLOR.default;
}, function (props) {
  return LINK_BORDER_BOTTOM[getVariantName(props)] || LINK_BORDER_BOTTOM.default;
}, function (props) {
  return LINK_HOVER_COLOR[getVariantName(props)] || LINK_HOVER_COLOR.default;
});